import { all, fork } from "redux-saga/effects";
import { sagaModules } from "./helpers";

export default function* sagas() {
  yield all([...sagaModules.map((saga) => fork(saga))]);
}
